// UX-47: budget chips must not rewrite history.
// While an AOR is still editable (or parked for a virement), its chip tracks the
// live pool. Once it is submitted or decided, the chip shows the check recorded
// at that moment, so a later pool shift can't flip an approved document's badge.
export const AOR_LIVE_CHIP_STATUSES = ["DRAFT", "RETURNED", "PENDING_VIREMENT"];

export function aorBudgetChip(aor) {
  if (AOR_LIVE_CHIP_STATUSES.includes(aor.status) || !aor.budgetCheckStatus) {
    return { status: aor.budgetCheck?.status, title: "Live budget check against the current pool" };
  }
  return {
    status: aor.budgetCheckStatus,
    title: "Budget check recorded at submission — not recomputed against today's pool",
  };
}
